export function shallowOmit<T extends object, K extends(
string | number | symbol)[]>(
    object: T,
    ...omitKeys: K
): Omit<T, K[number]> {
    const targetObject = { ...object };
    for (const path of omitKeys) {
        delete targetObject[path as keyof T];
    }
    return targetObject;
}
